import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Button, Grid } from "@mui/material";
import { useEffect } from "react";
import AdaptacionesCurriculares from "../../components/Form/Fields/AdaptacionesCurriculares";
import CantidadEstudiantes from "../../components/Form/Fields/CantidadEstudiantes";
import CaracteristicasEspacio from "../../components/Form/Fields/CaracteristicasEspacio";
import Caracterizacion from "../../components/Form/Fields/Caracterizacion";
import CondicionesContexto from "../../components/Form/Fields/CondicionesContexto";
import DuracionActividad from "../../components/Form/Fields/DuracionActividad";
import Edad from "../../components/Form/Fields/Edad";
import ObjetivosEspecificos from "../../components/Form/Fields/ObjetivosEspecificos";
import TemaClase from "../../components/Form/Fields/TemaClase";
import LudicaYJuegosCardImg from "../../components/UmmIApps/Cards/LudicaYJuegosCardImg.png";
import { useActividadesContext } from "../../components/UmmIACategories/Hook/useActividades";
import UmmiaAppsLayout from "../../components/UmmIACategories/Layout/UmmiaAppsLayout";
import CurriculumTabs from "../../components/CurriculumTabs/CurriculumTabs";
import { isSendButtonDisabled } from "../../config/sendButtonRules";

const LudicaYJuegosPage = () => {
  const {
    nivelId,
    materiaId,
    handleBack,
    promptData,
    toggleCamposAvanzados,
    mostrarCamposAvanzados,
    setTextoInicial,
    handleNivelChange,
    handleAsignaturaChangeLocal,
    handleInitialPromptData,
    handleNivelTPChange,
    handleAsignaturaTPChangeLocal,
    clearTP,
    setPromptData,
    nivelTPId,
    asignaturaTPId,
  } = useActividadesContext();


  //Variable para condicionar la habilitación del botón "Generar"
 const isButtonDisabled =  isSendButtonDisabled("aprendizaje_ludica", { promptData });
   
  const colorIconBack = "#BA4534";

  useEffect(() => {
    const init = {
      caracterizacion: "",
      tema: "",
      condiciones_contexto: "",
      adaptaciones_curriculares: "",
      edad: 4,
      cantidad_estudiantes: 1,
      duracion: 5,
      objetivos_especificos: "",
      caracteristicas_espacio: "",
    };
    handleInitialPromptData(init, "aprendizaje_ludica");
    setTextoInicial(
      "Esta es la propuesta que tengo para ti. Puedes revisarla y modificar cualquier parte según tus necesidades. Ajusta los parámetros en 'Mostrar campos', genera una nueva versión con 'Volver a generar' o personaliza el contenido con 'Editar'. Si prefieres trabajar en otra plataforma, usa 'Copiar' para llevar el texto donde desees."
    );
  }, []);

  return (
    <>
      <UmmiaAppsLayout
        onBack={handleBack}
        imageSrc={LudicaYJuegosCardImg}
        backgroundColorImage={
          "linear-gradient(180deg, #FFFFFF 0%, #E3B5AE 100%, #C86A5D 100%)"
        }
        titleColor="#BA4534"
        title="Actividades lúdicas y juegos"
        description="Crea juegos y actividades interactivas que motiven a tus alumnos a explorar y reforzar conocimientos"
        isButtonDisabled={isButtonDisabled}
        colorIconBack={colorIconBack}
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
           
              <CurriculumTabs
                nivelId={nivelId}
                materiaId={materiaId}
                nivelTPId={nivelTPId}
                asignaturaTPId={asignaturaTPId}
                handleNivelChange={handleNivelChange}
                handleNivelTPChange={handleNivelTPChange}
                handleAsignaturaChangeLocal={handleAsignaturaChangeLocal}
                handleAsignaturaTPChangeLocal={handleAsignaturaTPChangeLocal}
                clearTP={clearTP}
                promptData={promptData}
                setPromptData={setPromptData}
              />
         
          </Grid>
        </Grid>

        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{ mb: 3, mt: 2 }}>
          <TemaClase />
        </Grid>
        <Grid item xs={12}>
          <Edad />
        </Grid>
        <Grid item xs={12}>
          <DuracionActividad />
        </Grid>
        <Grid item xs={12}>
          <CantidadEstudiantes />
        </Grid>

        <Grid item xs={12} container justifyContent="center" sx={{ mb: 3 }}>
          <Button
            variant="text"
            sx={{ color: "#336B87" }}
            onClick={toggleCamposAvanzados}
            endIcon={
              mostrarCamposAvanzados ? <ExpandLessIcon /> : <ExpandMoreIcon />
            }
          >
            {mostrarCamposAvanzados
              ? "Ocultar opciones avanzadas"
              : "Mostrar opciones avanzadas (opcional)"}
          </Button>
        </Grid>
        {/* Campos avanzados */}
        {mostrarCamposAvanzados && (
          <>
            <Grid item xs={12}>
              <ObjetivosEspecificos />
            </Grid>
            <Grid item xs={12}>
              <CaracteristicasEspacio />
            </Grid>
            <Grid item xs={12}>
              <CondicionesContexto />
            </Grid>
            <Grid item xs={12}>
              <Caracterizacion />
            </Grid>
            <Grid item xs={12}>
              <AdaptacionesCurriculares />
            </Grid>
          </>
        )}
      </UmmiaAppsLayout>
    </>
  );
};

export default LudicaYJuegosPage;
